"use client";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { Button, Button_T } from "@ui/components";
import { SectionTemplate } from "components/individuals/blocks";
import { ButtonProp } from "lib/gcms";

export interface EnterpriseAboutSectionProps {
  title: string;
  titleColor: string;
  subtitle: string;
  additionalText: string;
  textColor: string;
  bg: string;
  buttons: Omit<ButtonProp, "buttonAction" | "id">[];
}

export const EnterpriseAboutSection = ({
  title,
  titleColor,
  subtitle,
  additionalText,
  textColor,
  bg,
  buttons,
}: EnterpriseAboutSectionProps) => {
  return (
    <SectionTemplate bg={bg} borderRadius="none">
      <Heading
        as={"h1"}
        color={titleColor}
        fontSize={{
          base: 26,
          md: 34,
          lg: 38,
          xl: 45,
        }}
        fontWeight={"bold"}
        lineHeight={1.2}
        mb={{
          base: 6,
          lg: 8,
        }}
      >
        {title}
      </Heading>
      <Box
        color={textColor}
        fontSize={{
          base: 16,
          lg: 17,
          xl: 18,
        }}
      >
        <Text
          mb={{
            base: 6,
            lg: 8,
          }}
          fontWeight={"semibold"}
        >
          {subtitle}
        </Text>
        <Text fontWeight={"semibold"}>{additionalText}</Text>
        <Flex
          mt={10}
          justify={{
            base: "center",
            md: "left",
          }}
        >
          {buttons.map((btn, index) => (
            <Button
              key={`advantage-section-btn-${index}`}
              bgColor={textColor}
              color={bg}
              fontSize={{
                base: 12,
                md: 14,
                lg: 16,
                xl: 18,
              }}
              fontWeight={"bold"}
              py={{
                base: "6",
                lg: "8",
              }}
              textTransform={"uppercase"}
              {...(btn as Button_T)}
            />
          ))}
        </Flex>
      </Box>
    </SectionTemplate>
  );
};
